import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseFormComponent } from '@app/shared/components/core/base-form.component';
import { AuthService } from '@common/auth/services/index';
import { KZ_DESKTOP_WEBSITE, desktopWebsiteFallback } from '../desktop-website';

@Component({
  selector: 'app-forgotpass',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
  standalone: false,
})
export class ForgotPasswordPage extends BaseFormComponent<any> implements OnInit {
  form: FormGroup;
  isSubmitting = false;
  sent = false;
  /** kzd-ac wave-2 review M4: the website's reset page, when this desktop was refused for want of an App Check token. */
  websiteUrl: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
  ) {
    super();
    this.title = 'Forgot Password';
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  async submit(): Promise<void> {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    this.websiteUrl = null;
    try {
      await this.authService.resetPassword(this.form.value.email);
      this.sent = true;
      this.toastService.create(
        this.languageService.get('app.pages.forgot.sent'),
        true,
      );
    } catch (error) {
      /* kzd-ac review M4: the desktop has no token the reset takes — send the person to the website instead. */
      this.websiteUrl = desktopWebsiteFallback(error, 'forgot-password');
      if (this.websiteUrl) return;
      console.error('resetPassword failed', error);
      this.toastService.create(
        this.languageService.get('app.pages.forgot.error'),
        false,
      );
    } finally {
      this.isSubmitting = false;
    }
  }

  /** Opens the website's reset page in the system browser (review M4). */
  openWebsite(): void {
    if (this.websiteUrl) KZ_DESKTOP_WEBSITE.open(this.websiteUrl);
  }

  backToLogin(): void {
    this.navCtrl.navigateBack('login');
  }
}
